<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <b-col lg="12">
              <b-form-group
                id="input-group-1"
                :label="$t('edu_seasons.name')"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="newItem.name"
                  type="text"
                  :placeholder="$t('edu_seasons.name')"
                />
              </b-form-group>
              <!-- .h_start_date -->
            </b-col>
            <b-col lg="6">
              <b-form-group
                id="input-group-2"
                :label="$t('edu_seasons.h_start_date')"
                label-for="input-2"
              >
                <date-picker
                  :placeholder="$t('edu_seasons.h_start_date')"
                  v-model="newItem.h_start_date"
                  :locale="'ar-eg'"
                  :calendar="'hijri'"
                  @change="h_start_date($event)"
                />
              </b-form-group>
              <!-- .h_end_date -->
            </b-col>

            <b-col lg="6">
              <b-form-group
                id="input-group-4"
                :label="$t('edu_seasons.g_start_date')"
                label-for="input-4"
              >
                <b-form-input
                  id="input-4"
                  v-model="newItem.g_start_date"
                  type="text"
                  readonly
                  :placeholder="$t('edu_seasons.g_start_date')"
                />
              </b-form-group>
              <!-- .g_end_date -->
            </b-col>
            <b-col lg="6">
              <b-form-group
                id="input-group-3"
                :label="$t('edu_seasons.h_end_date')"
                label-for="input-3"
              >
                <date-picker
                  :placeholder="$t('edu_seasons.h_end_date')"
                  v-model="newItem.h_end_date"
                  :locale="'ar-eg'"
                  :calendar="'hijri'"
                  @change="h_end_date($event)"
                />
              </b-form-group>
              <!-- .g_start_date -->
            </b-col>
            <b-col lg="6">
              <b-form-group
                id="input-group-5"
                :label="$t('edu_seasons.g_end_date')"
                label-for="input-5"
              >
                <b-form-input
                  id="input-5"
                  v-model="newItem.g_end_date"
                  readonly
                  type="text"
                  :placeholder="$t('edu_seasons.g_end_date')"
                />
              </b-form-group>
              <!-- .status -->
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}</b-button
              >
            </b-col>
            <b-col lg="6">
              <b-button block @click="goToTable()" variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-button
              >
            </b-col>
          </b-row>
        </b-form></validation-observer
      >
    </b-col></b-row
  >
</template>

<script>
import Controller from "../../../../Controllers/Edu_seasonsController";
import config from "../../../../config/config";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VueDatetimeJs from "vue-datetime-js";

import { required } from "@validations";
const controller = new Controller();
export default {
  name: "EduSeasonsForm",
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
    "date-picker": VueDatetimeJs,
  },
  props: ["newItem", "wizard"],
  data() {
    return {
      file: {},
      
      season: {},
    };
  },
  methods: {
    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      let ret = await new Controller().From(this.newItem, "FormData");
      if (ret) {
        if (this.wizard) {
          this.season = ret[1][0];
        } else {
          this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
          this.$parent.$parent.firstTab();
        }
      }
    },
    getSeason() {
      return this.season;
    },
    h_start_date(ev) {
      this.newItem.g_start_date = ev.toISOString().split("T")[0];
    },
    h_end_date(ev) {
      this.newItem.g_end_date = ev.toISOString().split("T")[0];
    },
  },
};
</script>
